import LinkGenerator from '@nerdwallet/nw-auth-links';
import appConfig from '@nerdwallet/app-config';
import { getDeployableInfo } from '@nerdwallet/seo-analytics';

const registerLink = (
  calc: string,
  {
    element,
    flow = '',
    location,
    anonymousUserId = '',
    deviceId = '',
    impressionId = '',
    pageName = '',
    pageViewId = '',
  }: {
    element: string;
    flow?: string;
    location: string;
    anonymousUserId?: string;
    deviceId?: string;
    impressionId?: string;
    pageName?: string;
    pageViewId?: string;
  },
  text = ''
): {
  url: string;
  text: string;
  href: string;
} => {
  const {
    deployable_name: deployableName,
    deployable_version: deployableVersion,
  } = getDeployableInfo();
  const linkGenerator = new LinkGenerator();
  const regLink = linkGenerator.register({
    redirectTo:
      typeof window !== 'undefined'
        ? `${appConfig.SITE_BASE_URL}${window.location.pathname}`
        : `${appConfig.SITE_BASE_URL}/mortgages/how-much-house-can-i-afford`,
    driverPageName: pageName || calc,
    driverLocation: location,
    driverSubLocation: location,
    driverElement: element,
    deployableName,
    deployableVersion,
    driverPageUrl:
      typeof window !== 'undefined'
        ? `${appConfig.SITE_BASE_URL}${window.location.pathname}`
        : `${appConfig.SITE_BASE_URL}/mortgages/how-much-house-can-i-afford`,
    driverPageViewId: pageViewId,
    driverContentId: impressionId,
    driverContentSource: 'web',
    driverFlowName: flow,
    anonymousUserId,
    mostRecentTraditionalDeviceId: deviceId,
  });
  return {
    url: regLink,
    text,
    href: regLink,
  };
};
export default registerLink;
